export default __webpack_public_path__ + "static/media/saayaHealthLogo.60b27d1f.webp";